import type { AuthResponseDataScopesInner, Permission, Resource } from '@seccl/client';

export const hasScope = (
  scopes: AuthResponseDataScopesInner[] = [],
  resource: Resource,
  permission: Permission
): boolean => {
  return scopes.some(scope => scope.scope === resource && scope.ranges?.includes(permission));
};
